import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4b5582a2&"
import script from "./footer.vue?vue&type=script&lang=ts&"
export * from "./footer.vue?vue&type=script&lang=ts&"
import style0 from "./footer.vue?vue&type=style&index=0&id=4b5582a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports